import styled from "styled-components";

const colors = {
  blue: "#307fe2",
  blueHover: "#2370ca",
  blueActive: "#1a5fad",
  blueRing: "rgba(48, 127, 226, 0.15)",
  red: "#e53e3e",
  redRing: "rgba(229, 62, 62, 0.15)",
  textPrimary: "#17222f",
  textSecondary: "#3c4c60",
  textMuted: "#6f7f93",
  textDisabled: "#8d9bad",
  border: "#d4dbe2",
  bgPage: "#f5f8fc",
  bgCard: "#ffffff",
};

const spacing = {
  cardPadding: "32px",
  cardMaxWidth: "480px",
  cardGap: "16px",
  mobileBreakpoint: "600px",
};

export const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

export const Header = styled.div`
  margin: 64px 0 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: ${spacing.cardMaxWidth};
  width: calc(100% - ${spacing.cardPadding});
  background-color: ${colors.bgCard};
  border-radius: 12px;
  padding: ${spacing.cardPadding};
  box-sizing: border-box;
  gap: ${spacing.cardGap};

  @media (max-width: ${spacing.mobileBreakpoint}) {
    width: 100%;
    border-radius: 0;
  }
`;

export const FooterSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${spacing.cardGap};
  max-width: ${spacing.cardMaxWidth};
  width: calc(100% - ${spacing.cardPadding});
  margin-top: ${spacing.cardGap};
  margin-bottom: 64px;
  box-sizing: border-box;
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  margin-top: 8px;
`;

export const Heading = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: ${colors.textPrimary};
  margin: 0;
  text-align: center;
  line-height: 32px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${colors.textSecondary};
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Input = styled.input<{ error?: string }>`
  border: 1px solid ${(props) => (props.error ? colors.red : colors.border)};
  &:focus {
    border: 1px solid ${(props) => (props.error ? colors.red : colors.blue)};
    outline: none;
    box-shadow: 0 0 0 3px
      ${(props) => (props.error ? colors.redRing : colors.blueRing)};
  }
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  padding: 0 12px;
  border-radius: 8px;
  box-sizing: border-box;
  color: ${colors.textSecondary};
  background-color: ${colors.bgCard};
  height: 48px;
  width: 100%;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:disabled {
    background-color: ${colors.bgPage};
    color: ${colors.textDisabled};
  }
`;

export const Button = styled.button`
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: inherit;
  box-sizing: border-box;
  height: 48px;
  text-align: center;
  border-radius: 28px;
  outline: none;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.blue};
  color: ${colors.bgCard};
  margin-top: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.blueHover};
  }

  &:active {
    background-color: ${colors.blueActive};
  }
`;

export const Text = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: ${colors.textMuted};
  font-family: Roboto, sans-serif;
  text-align: center;
  line-height: 24px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ErrorText = styled.span`
  color: ${colors.red};
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  margin-top: 2px;
`;

export const Link = styled.a`
  font-size: 16px;
  font-weight: 400;
  color: ${colors.blue};
  font-family: Roboto, sans-serif;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
